export const API_BASE_PYTHON_SERVICE = 'https://mapping.oddismaps.com/';
export const API_BASE_URL = 'https://backend.oddismaps.com/';
export const API_BASE_URL_DASHBOARD = 'https://metrics.oddismaps.com/';
export const API_BASE_URL_SECURITY = 'https://modulo.oddismaps.com/';
export const API_BASE_URL_AI = 'https://ai.oddismaps.com/';
